export var NotificationsActions;
(function (NotificationsActions) {
  let ReloadCount = /*#__PURE__*/(() => {
    class ReloadCount {
      static {
        this.type = '[Notifications] ReloadCount';
      }
      constructor() {}
    }
    return ReloadCount;
  })();
  NotificationsActions.ReloadCount = ReloadCount;
  let Fetch = /*#__PURE__*/(() => {
    class Fetch {
      static {
        this.type = '[Notifications] Fetch';
      }
      constructor() {}
    }
    return Fetch;
  })();
  NotificationsActions.Fetch = Fetch;
  let StopFetching = /*#__PURE__*/(() => {
    class StopFetching {
      static {
        this.type = '[Notifications] StopFetching';
      }
      constructor() {}
    }
    return StopFetching;
  })();
  NotificationsActions.StopFetching = StopFetching;
  let FetchMore = /*#__PURE__*/(() => {
    class FetchMore {
      static {
        this.type = '[Notifications] FetchMore';
      }
      constructor() {}
    }
    return FetchMore;
  })();
  NotificationsActions.FetchMore = FetchMore;
  let ReloadNotifications = /*#__PURE__*/(() => {
    class ReloadNotifications {
      static {
        this.type = '[Notifications] ReloadNotifications';
      }
      constructor() {}
    }
    return ReloadNotifications;
  })();
  NotificationsActions.ReloadNotifications = ReloadNotifications;
  let DeleteNotification = /*#__PURE__*/(() => {
    class DeleteNotification {
      static {
        this.type = '[Notifications] DeleteNotification';
      }
      constructor(item) {
        this.item = item;
      }
    }
    return DeleteNotification;
  })();
  NotificationsActions.DeleteNotification = DeleteNotification;
  let ToggleReadNotification = /*#__PURE__*/(() => {
    class ToggleReadNotification {
      static {
        this.type = '[Notifications] ToggleReadNotification';
      }
      constructor(id, hasBeenRead) {
        this.id = id;
        this.hasBeenRead = hasBeenRead;
      }
    }
    return ToggleReadNotification;
  })();
  NotificationsActions.ToggleReadNotification = ToggleReadNotification;
})(NotificationsActions || (NotificationsActions = {}));